import YoutubeVideoPlayer from './VideoPlayers/YoutubeVideoPlayer.js';

function createIframeElementFromVideoElement(event) {
  let videoElement = event.target;

  while (
    !videoElement.classList.contains('video-element') &&
    videoElement.parentNode
  ) {
    videoElement = videoElement.parentNode;
  }

  if (!videoElement) {
    return;
  }

  videoElement.removeEventListener(
    'touchstart',
    createIframeElementFromVideoElement
  );
  videoElement.removeEventListener(
    'mouseover',
    createIframeElementFromVideoElement
  );

  const videoButton = videoElement.querySelector(
    '.video-element__video-button'
  );

  if (videoButton) {
    videoButton.removeEventListener(
      'focus',
      createIframeElementFromVideoElement
    );
    videoButton.removeEventListener(
      'click',
      createIframeElementFromVideoElement
    );
  }

  const videoPlayerWrapper = videoElement.querySelector(
    '.video-element__video-player'
  );

  if (
    !videoButton ||
    !videoPlayerWrapper ||
    !videoPlayerWrapper.dataset.videoIframe
  ) {
    return;
  }

  videoPlayerWrapper.innerHTML += videoPlayerWrapper.dataset.videoIframe;
  videoPlayerWrapper.removeAttribute('data-video-iframe');

  const videoIframe = videoElement.querySelector('iframe');

  if (!videoButton || !videoIframe) {
    return;
  }

  const videoPlayer = new YoutubeVideoPlayer(videoIframe, {}, true);

  videoButton.addEventListener(
    'click',
    () => {
      videoPlayer.load(true);
      videoElement.classList.add('video-element--video-loaded');
    },
    window.supportPassive
  );
}

export default class VideoElement {
  init() {
    const videoElements = Array.from(
      document.querySelectorAll('.video-element')
    );

    for (let videoElement of videoElements) {
      const videoButton = videoElement.querySelector(
        '.video-element__video-button'
      );

      if (videoButton) {
        videoButton.addEventListener(
          'focus',
          createIframeElementFromVideoElement,
          false
        );
        videoButton.addEventListener(
          'click',
          createIframeElementFromVideoElement,
          false
        );
      }

      videoElement.addEventListener(
        'mouseover',
        createIframeElementFromVideoElement,
        false
      );
      videoElement.addEventListener(
        'touchstart',
        createIframeElementFromVideoElement,
        false
      );
    }
  }
}
